import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {uid} from 'react-uid';
import {Box, Radio, FormControl} from '@tenancy.nz/ui';

function SelectionGroup({
  disabled = false,
  errorMessage = '',
  label,
  name,
  options,
  onChange,
  required = false,
  showError = false,
  value = '',
}) {
  const [selection, setSelection] = useState(value || '');

  const handleChange = e => {
    setSelection(e.target.value);
    onChange(e.target.value);
  };

  return (
    <FormControl
      errorMessage={errorMessage}
      fullWidth
      label={label}
      required={required}
      name={name}
      showError={showError}
      disabled={disabled}>
      {options.map((option, i) => (
        <Box key={uid(option)} margin="6px 0 16px 0">
          <Radio
            checked={selection === option.value}
            disabled={disabled}
            label={option.label}
            name={name}
            onChange={handleChange}
            value={option.value}
            color="primary"
            id={`slot-${i}`}
          />
        </Box>
      ))}
    </FormControl>
  );
}

SelectionGroup.propTypes = {
  /**
   * If `true`, will make fields unselectable.
   */
  disabled: PropTypes.bool,

  /**
   * Text represents the error message.
   */
  errorMessage: PropTypes.string,

  /**
   * Text to display as lable for the group
   */
  label: PropTypes.string.isRequired,

  /**
   * HTML attribute of checkobx element.
   */
  name: PropTypes.string.isRequired,

  /**
   * List of options to render as list.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,

  /**
   * On change event handler.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * If `true`,  will be marked as required.
   */
  required: PropTypes.bool,

  /**
   * If `true`,  will show error message.
   */
  showError: PropTypes.bool,

  /**
   * A selected value.
   */
  value: PropTypes.string,
};

export default SelectionGroup;
